import PolyscapeLanding from './PolyscapeLanding'

function App() {
  return (
      <PolyscapeLanding />
  )
}

export default App